import {Component, Vue} from 'vue-property-decorator'
import {menuBtn} from '@/utils/menu_level2_button'
import {UserModule} from '@/store/modules/user'
import {formatDate} from '@/utils/timeFilter'
import {gettHeaderByType, getMarketCooperation} from '@/api/common'
import {
    getProjectMarketCooperationList,
    getProjectMarketCooperationByMarketCooperationId,
    setProjectMarketCooperation,
    getPreProjectMarketCooperation,
    delPreProjectMarketCooperation,
    projectMarketCooperationExportData
} from '@/api/projectList'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

const projectTypeFilter = commonData.projectTypeZeroArray
@Component({
    components:{
        MoreUsersFilter
    }
})
export default class CooperativePartnerProject extends Vue {
    tableHeader = []
    tableData = []
    total = 0
    page = 1
    limit = 20
    tableKey = Math.random()
    loading = false
    dialogShow = false
    projectTypeFilter = projectTypeFilter
    dialogConfirmButtonDisabled = false

    filter_projectName = ''
    filter_teacherName = ''
    filter_marketCooperationName = ''
    filter_marketCooperationDirectorUserId: string[] = []
    filter_superiorMarketCooperationName = ''
    filter_souCourseType = 0
    filter_Type = null
    filter_marketCooperationSource = ''
    filter_marketCooperationCommissionType = ''
    filter_souCourseSchoolBegin: Date[] = []

    dialogPartnerName = ''
    dialogPartnerPage = 1
    dialogPartnerTotal = 0
    dialogPartnerLimit = 20
    dialogPartnerTableData = []
    dialogPartnerCheckedTableRow = [] //选中的合作伙伴list

    dialogProjectName = ''
    dialogProjectPage = 1
    dialogProjectTotal = 0
    dialogProjectLimit = 20
    dialogProjectTableLoading = false
    dialogProjectTableData = []
    dialogProjectCheckedTableRow = [] //被选中的项目列表数据
    exportButtonDisabled = false
    exportHeaderDialogVisible = false
    checked = false
    allloading = false
    timer = null
    timer1 = null
    timer2 = null
    loadingPartnerName = false
    // isReadonly = false
    projectIsCheckedData = []


    get souCourseSchoolBegin() {
        let str = ''
        if (this.filter_souCourseSchoolBegin) {
            str = this.filter_souCourseSchoolBegin.length > 0 ? formatDate('yyyy-MM-dd', new Date(this.filter_souCourseSchoolBegin[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.filter_souCourseSchoolBegin[1])) : ''
        }
        return str
    }

    created() {
        this.getTableHeader()
        this.getTableData()
    }

    buttonShow = menuBtn

    handleTypeFilter(val) {


    }

    pageChange(page: number) {
        if (this.timer2 !== null) clearTimeout(this.timer2)
        this.timer2 = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    async getTableData() {
        this.loading = true

        const obj = {
            souCourseName: this.filter_projectName,
            souTeacherName: this.filter_teacherName,
            marketCooperationName: this.filter_marketCooperationName,
            marketCooperationDirectorUserIdList: this.filter_marketCooperationDirectorUserId,
            superiorMarketCooperationName: this.filter_superiorMarketCooperationName,
            souCourseTypeId: this.filter_souCourseType,
            marketCooperationSource: this.filter_marketCooperationSource,
            marketCooperationCommissionType: this.filter_marketCooperationCommissionType,
            souCourseSchoolBegin: this.souCourseSchoolBegin,
            page: this.page,
            limit: this.limit,
        }
        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) delete obj[key]
        }
        const data: any = await getProjectMarketCooperationList(obj)
        const {allNum, projectMarketCooperationList} = data
        this.tableData = projectMarketCooperationList,
            this.total = allNum
        this.loading = false
        // this.isReadonly = false
        // this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
    }

    async exportData(keys: string = '') {
        this.exportButtonDisabled = true
        projectMarketCooperationExportData({
            souCourseName: this.filter_projectName,
            souTeacherName: this.filter_teacherName,
            marketCooperationName: this.filter_marketCooperationName,
            marketCooperationDirectorUserIdList: this.filter_marketCooperationDirectorUserId,
            superiorMarketCooperationName: this.filter_superiorMarketCooperationName,
            souCourseTypeId: this.filter_souCourseType,
            marketCooperationSource: this.filter_marketCooperationSource,
            marketCooperationCommissionType: this.filter_marketCooperationCommissionType,
            souCourseSchoolBegin: this.souCourseSchoolBegin,
            keys,
        })
            .then(() => {
                this.$message.success('数据已转入后台导出, 请前往下载列表查看')
            })
            .finally(() => {
                this.exportButtonDisabled = false
            })
    }

    // 点击上架项目按钮
    async clickShelfProjectButton() {
        /*是否存在预提交合作伙伴项目*/
        const data: any = await getPreProjectMarketCooperation()
        if (data.isHave) {
            const url = this.$router.resolve({
                path: 'shelfPanterProject',
                params: {
                    id: '1',
                    // isAll: this.checked ? '1' : '0'
                }
            }).href
            const win = window.open(url, '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    delPreProjectMarketCooperation()
                    clearInterval(timer)
                }
            }, 500)
        } else {
            this.dialogShow = true
            this.dialogProjectPage = 1
            this.dialogPartnerPage = 1
            this.getMarketCooperation()
        }
    }

    // 获取弹框中的全部合作伙伴
    async getMarketCooperation() {
        this.loadingPartnerName = true

        const data: any = await getMarketCooperation({
            name: this.dialogPartnerName,
            isShelf: '1',
            page: this.dialogPartnerPage,
            limit: 20
        })
        this.dialogPartnerTableData = data.marketCooperationList
        this.dialogPartnerTotal = data.allNum
        this.loadingPartnerName = false
        // this.isReadonly = false
    }

    // 获取弹框中的项目列表
    async getProjectMarketCooperationByMarketCooperationId() {
        if(this.dialogPartnerCheckedTableRow.map(item => item.id).length==0){
            this.$message.error('至少选一个机构')
            return false;
        }
        this.dialogProjectTableLoading = true
        const obj = {
            marketCooperationIdList: this.dialogPartnerCheckedTableRow.map(item => item.id),
            name: this.dialogProjectName,
            souCourseTypeId: Number(this.filter_Type),
            isTwo: '1',
            page: this.dialogProjectPage,
            limit: this.dialogProjectLimit,
            isDraft: '0'
        }
        if (!this.filter_Type) {
            delete obj.souCourseTypeId
        }
        const data: any = await getProjectMarketCooperationByMarketCooperationId(obj)
        const {allNum, projectAllList} = data
        this.dialogProjectTotal = allNum
        this.dialogProjectTableData = projectAllList
        //    判断全选按钮是否选中状态 实现每一页都选中或者不选
        if(this.checked){
            this.dialogProjectTableData.forEach(item => {
                if (item.isChoice) {
                    (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(item);
                    item.enable = false
                }
            })
        }else{
            this.dialogProjectTableData.forEach(item => {
                // 一旦选定 禁止单独取消 取消全选才可以点击
                if (item.enable == false) {
                    item.enable = true
                }
            });
        }
        this.dialogProjectTableLoading = false
        // this.isReadonly = false
    }

    dialogPartnerSelectionChange(arr) {
        // this.dialogPartnerCheckedTableRow = arr
        // this.dialogProjectCheckedTableRow = [];
        // // this.dialogProjectTableData.forEach((item)=>{
        // //     item.enable = true  // 变更为可选
        // // })
        // this.checked = false;
        // // (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection();
        // this.projectPageChange(1)
        // if (arr.length == 0) return false;

        this.dialogPartnerCheckedTableRow = arr
        this.dialogProjectCheckedTableRow = []
        this.checked = false;
        (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection(); // 取消项目选中
        if (arr.length > 0) {
            this.projectPageChange(1) // 重新获取项目列表数据
        } else {
            /* 不重新获取数据 将原来的恢复*/
            this.dialogProjectTableData.forEach((item)=>{
                item.enable = true  // 变更为可选
            });
            this.dialogProjectTableData = []
            return false;
        }

    }
    clickRow(row) {
        (this.$refs.dialogPartnerTable as HTMLFormElement).toggleRowSelection(row);
    }

    clickRow1(row) {
        if (row.isChoice) {
            (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(row);
        }
    }

    dialogProjectSelectionChange(arr) {
        this.dialogProjectCheckedTableRow = arr
    }



    limitChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    partnerPageChange(page: number) {
        if (this.timer1 !== null) clearTimeout(this.timer1)
        this.timer1 = setTimeout(() => {
            this.dialogPartnerPage = page
            this.getMarketCooperation()
        }, 1000)
    }

    partnerLimitChange(limit: number) {
        this.dialogPartnerLimit = limit
        this.getMarketCooperation()
    }

    /*选择项目翻页*/
    projectPageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.dialogProjectPage = page
            this.getProjectMarketCooperationByMarketCooperationId()

        }, 1000)
    }
    /*选择项目翻页*/
    projectLimitChange(limit: number) {
        this.dialogProjectLimit = limit
        this.getProjectMarketCooperationByMarketCooperationId()


    }

    // 禁用选项
    dialogProjectTableSelectable(row) {
        // if (row.isChoice == false) {
        //     return row.isChoice
        // } else if (row.enable == false) {
        //     return row.enable
        // }
        // if (row.isChoice) {
        //     return row.isChoice
        // } else if (row.enable) {
        //     return row.enable
        // }
        if (row.enable == true) {
            return row.isChoice && row.enable // true 为可选择； false为不可选
        }else{
            return row.isChoice
        }
    }

    clickTableRow(row) {
        // window.open(window.location.origin + this.$route.matched[0].path + '/partnerProjectInfo?id=' + row.id, '_blank')
    }

    /*弹款确认*/
    async dialogConfirm() {

        if (this.dialogPartnerCheckedTableRow.length === 0 || this.dialogProjectCheckedTableRow.length === 0) {
            this.$message.error(`
                请选择${this.dialogPartnerCheckedTableRow.length === 0 ? '合作伙伴' : ''}
                ${this.dialogPartnerCheckedTableRow.length === 0 && this.dialogProjectCheckedTableRow.length === 0 ? '、' : ''}
                ${this.dialogProjectCheckedTableRow.length === 0 ? '项目' : ''}`
            )
            return
        }
        this.dialogConfirmButtonDisabled = true
        const isAll = this.checked ? '1' : '0'
        this.allloading = true
        /*上架项目预提交(上架项目第二步结束)/添加项目*/
        setProjectMarketCooperation({
            marketCooperationIdList: this.dialogPartnerCheckedTableRow.map(item => item.id),
            projectAllIdList: this.checked == false ? this.dialogProjectCheckedTableRow.map(item => item.id) : [],
            isTwo: '1',
            isAll: isAll
        }).then(() => {
            const url = this.$router.resolve({
                path: 'shelfPanterProject',
                // query: {
                //     isAll: this.checked ? '1' : '0'
                // }
            }).href
            const win = window.open(url, '_blank')
            this.allloading = false
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    delPreProjectMarketCooperation()
                    clearInterval(timer)
                }
            }, 500)
            this.dialogConfirmButtonDisabled = false
            this.dialogCancle()

        }).catch(() => {
            this.dialogConfirmButtonDisabled = false
            this.allloading = false
        })
    }

    dialogCancle() {
        (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection();
        (this.$refs.dialogPartnerTable as HTMLFormElement).clearSelection();
        this.dialogShow = false
        this.dialogPartnerCheckedTableRow = []
        this.dialogProjectCheckedTableRow = []
        this.dialogPartnerTableData = []
        this.dialogProjectTableData = []
        this.dialogPartnerTotal = 0
        this.dialogProjectTotal = 0;
    }

    async getTableHeader() {
        const data: any = await gettHeaderByType(6)
        this.tableHeader = data.headerUserList
    }

    handleSelectionChange(rows) {
        // todo 多选表格
    }

    // 选中全部符合条件的项目
    clickedAll() {
        this.projectIsCheckedData = [];
        (this.$refs.dialogProjectTable as HTMLFormElement).clearSelection(); // 全部取消勾选
        if (this.checked) {
            this.dialogProjectTableData.forEach(item => {
                if (item.isChoice == true) {

                    (this.$refs.dialogProjectTable as HTMLFormElement).toggleRowSelection(item);
                    this.projectIsCheckedData.push(item)
                    // 一旦选定 禁止单独取消
                    item.enable = false
                }
            })
        } else {
            // 取消全部勾选
            this.dialogProjectTableData.forEach(item => {
                    item.enable = true  // 重置为可选
            });
            this.dialogProjectCheckedTableRow = []
        }
    }

    changeUserList(e) {
        this.filter_marketCooperationDirectorUserId = e.id
        if (this.timer2 !== null) clearTimeout(this.timer2)
        this.timer2 = setTimeout(() => {
            this.page = 1
            this.getTableData()
        }, 1000)
    }

}
